// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { Fragment, useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Trans as T, useTranslation } from 'react-i18next';
import hopt from 'hola_opt';
import user_agent from '/util/user_agent.js';
import zcountry from '/util/country.js';
import zmembership from '../../../../svc/account/pub/membership.js';
import { get_plan_display_options } from '../../../../svc/vpn/pub/common_ui.js';
import { get_width } from '../lib/screen_util.ts';
import './plan.module.less';
const sys = user_agent.guess();

const Plan_button = ({
  plan,
  best,
  has_free,
  title,
  arrow
}) => {
  const _useTranslation = useTranslation(),
        t = _useTranslation.t;

  const cls = cn('hola_btn hola_btn--sm hola_btn--round', {
    'hola_btn--white': !best,
    'hola_btn--gray': plan.id == 'free'
  });
  const text = t(plan.id == 'free' ? 'Install now' : title ? title : has_free || sys.mobile ? 'Get Hola Premium' : 'Upgrade');
  const hide_arrow = !arrow && (has_free || sys.mobile);
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, hide_arrow ? text : /*#__PURE__*/React.createElement("span", null, text));
};

const Free_list = () => {
  return /*#__PURE__*/React.createElement("ul", {
    className: "plan-plus-list"
  }, /*#__PURE__*/React.createElement("li", null, "No privacy"), /*#__PURE__*/React.createElement("li", null, "Limited Data"), /*#__PURE__*/React.createElement("li", null, "1 device"), /*#__PURE__*/React.createElement("li", null, "Share minimal resources"));
};

const to_decimal_fixed = p => Math.round(p) !== p ? p.toFixed(2) : p;

const Plan_header = props => {
  const plan = props.plan,
        short = props.short,
        currency = props.currency,
        popular = props.popular,
        discount_off = props.discount_off,
        show_renewal = props.show_renewal;

  const _useTranslation2 = useTranslation(),
        t = _useTranslation2.t;

  const cp = zcountry.currency2prefix(currency);
  const price_o = zmembership.get_price_plan(plan, currency);
  const id = plan.id,
        short_name = plan.short_name,
        every = plan.every;
  const month_price = price_o.month_price,
        regular_price = price_o.regular_price,
        price = price_o.price,
        discount_percent = price_o.discount_percent,
        renewal_price = price_o.renewal_price;
  if (id == 'free') return /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-header"
  }, /*#__PURE__*/React.createElement("span", null, "Free"));

  const _get_plan_display_opt = get_plan_display_options(plan),
        show_renewal_billing_label = _get_plan_display_opt.show_renewal_billing_label;

  const cp_wide = cp.length > 1;

  const _get_plan_display_opt2 = get_plan_display_options(plan),
        show_line_through_regular_price = _get_plan_display_opt2.show_line_through_regular_price;

  const regular = show_line_through_regular_price ? /*#__PURE__*/React.createElement("span", {
    className: "regular-price"
  }, zcountry.format_price(!cp_wide ? currency : '', regular_price)) : null;
  const renewal = show_renewal_billing_label ? /*#__PURE__*/React.createElement("span", {
    className: "regular-price"
  }, zcountry.format_price(currency, plan.renewal_price || renewal_price)) : null;
  const discount_value = discount_percent || plan.discount_percent || 0;
  return short ? /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("span", null, zcountry.format_price(currency, month_price || price)), /*#__PURE__*/React.createElement("span", {
    className: "price-per"
  }, "/ ", t(month_price ? 'month' : every))), /*#__PURE__*/React.createElement("div", {
    className: "sub-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, t(short_name + ' plan'), plan.free_period && /*#__PURE__*/React.createElement("span", {
    className: "price-free"
  }, "+ ", zmembership.get_per(plan.free_period, true), " Free")), /*#__PURE__*/React.createElement("div", {
    className: "pricing"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prices"
  }, renewal ? /*#__PURE__*/React.createElement(Fragment, null, renewal, " ", zcountry.format_price(currency, price.toFixed(0))) : cp_wide ? /*#__PURE__*/React.createElement(Fragment, null, cp, " ", regular, " ", price.toFixed(2)) : /*#__PURE__*/React.createElement(Fragment, null, regular, " ", zcountry.format_price(currency, price))), /*#__PURE__*/React.createElement("div", {
    className: "billed"
  }, renewal ? /*#__PURE__*/React.createElement(Fragment, null, "for the first ", every, /*#__PURE__*/React.createElement("sup", null, "*")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(T, null, "billed every ", every))), discount_percent && !renewal && /*#__PURE__*/React.createElement("span", {
    className: "discount"
  }, discount_off ? `${discount_value}% off` : `${t('save')} ${discount_value}%`)))) : /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement(T, null, short_name)), /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("span", null, zcountry.format_price(currency, month_price || price)), /*#__PURE__*/React.createElement("span", {
    className: "price-per"
  }, "/ ", t(month_price ? 'month' : every))), /*#__PURE__*/React.createElement("div", {
    className: "per"
  }, t('per ' + (month_price ? 'month' : every))), /*#__PURE__*/React.createElement("div", {
    className: "sub-title"
  }, regular, " ", zcountry.format_price(currency, price)), renewal && show_renewal && /*#__PURE__*/React.createElement("div", {
    className: "renewal-pricing"
  }, renewal, /*#__PURE__*/React.createElement("div", {
    className: "billed"
  }, zcountry.format_price(currency, to_decimal_fixed(price), true), " ", /*#__PURE__*/React.createElement("span", null, "for the first ", every, /*#__PURE__*/React.createElement("sup", null, "*")))), /*#__PURE__*/React.createElement("div", {
    className: "billed"
  }, /*#__PURE__*/React.createElement(T, null, "billed ", every == 'month' ? 'monthly' : `every ${every}`)), id != 'free' && discount_value > 0 && !popular && !renewal && /*#__PURE__*/React.createElement("div", {
    className: "save-badge"
  }, discount_off ? `${discount_value}% off` : `Save ${discount_value}%`));
};

const Plus_plan = function Plus_plan(props) {
  var _plan$period;

  const _useTranslation3 = useTranslation(),
        t = _useTranslation3.t;

  const plan_ref = useRef();
  const plan = props.plan,
        selected = props.selected,
        on_click = props.on_click,
        best = props.best,
        button = props.button,
        popular = props.popular,
        tip = props.tip,
        has_free = props.has_free,
        hola = props.hola,
        short = props.short,
        discount_off = props.discount_off,
        show_renewal = props.show_renewal,
        bottom = props.bottom,
        button_title = props.button_title,
        arrow = props.arrow;

  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        scrolled = _useState2[0],
        set_scrolled = _useState2[1];

  useEffect(() => {
    const handle_scroll = () => {
      if (!plan_ref.current || scrolled || get_width() > 767) return;
      const b = plan_ref.current.getBoundingClientRect();
      if (b.top < 300) set_scrolled(true);
    };

    window.addEventListener('scroll', handle_scroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handle_scroll);
  }, []);
  const currency = props.currency || zmembership.get_plan_currency(plan, hopt.user_currency);

  const _zmembership$get_pric = zmembership.get_price_plan(plan, currency),
        discount_percent = _zmembership$get_pric.discount_percent;

  const wrapper_cls = cn('plan-plus-wrapper', best && 'best', scrolled && 'scrolled');
  const cls = cn('plan-plus', `plan-type-${plan.type}`, {
    short,
    'plan-plus-selected': selected,
    'plan-plus-free': plan.id == 'free',
    'plan-plus-best': best,
    'plan-plus-hola': hola,
    'plan-plus-no_discount': !popular && !best && !plan.discount
  });
  return /*#__PURE__*/React.createElement("div", {
    className: wrapper_cls,
    ref: plan_ref
  }, /*#__PURE__*/React.createElement("a", {
    className: cls,
    onClick: () => on_click(plan),
    "data-plan-id": plan.id,
    "data-plan": (_plan$period = plan.period) === null || _plan$period === void 0 ? void 0 : _plan$period.replace(/\s/g, '').toLowerCase()
  }, short ? /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-content"
  }, best && /*#__PURE__*/React.createElement("div", {
    className: "best-badge"
  }, /*#__PURE__*/React.createElement("p", null, t('Best Value'))), /*#__PURE__*/React.createElement(Plan_header, {
    plan: plan,
    best: best,
    short: short,
    currency: currency,
    discount_off: discount_off,
    show_renewal: show_renewal
  }), /*#__PURE__*/React.createElement("button", {
    className: "hola_btn hola_btn--sm"
  }, /*#__PURE__*/React.createElement(T, null, "Select"))) : /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-content"
  }, plan.id == 'free' && /*#__PURE__*/React.createElement("div", {
    className: "free-badge"
  }, "Free"), best && /*#__PURE__*/React.createElement("div", {
    className: "best-badge"
  }, /*#__PURE__*/React.createElement("p", null, t('Best Value')), /*#__PURE__*/React.createElement("p", null, "Save ", discount_percent, "%")), popular && /*#__PURE__*/React.createElement("div", {
    className: "popular-badge"
  }, /*#__PURE__*/React.createElement("p", null, t('Most popular')), /*#__PURE__*/React.createElement("p", null, "Save ", discount_percent, "%")), plan.id == 'free' ? /*#__PURE__*/React.createElement(Free_list, null) : /*#__PURE__*/React.createElement(Plan_header, {
    plan: plan,
    best: best,
    currency: currency,
    popular: popular,
    discount_off: discount_off,
    show_renewal: show_renewal
  }), button && /*#__PURE__*/React.createElement(Plan_button, {
    plan: plan,
    best: best,
    has_free: has_free,
    title: button_title,
    arrow: arrow
  }), bottom)), /*#__PURE__*/React.createElement("div", {
    className: "spacer"
  }), tip && /*#__PURE__*/React.createElement("div", {
    className: "plan-plus-tip"
  }, tip));
};

export { Plus_plan };